export default __webpack_public_path__ + "app/components/report/report-modal.html";